import { getServicePrice } from '@repo/api-adapters/services/service-price.api';
import { type ServicesBasePath } from '@repo/api-adapters/services/services.utils';
import { type ServicePricePayload } from '@repo/types/service-price';
import { useQueries } from '@tanstack/react-query';

import { API } from './utils.api';

export interface ServicePriceRequest {
    timeWindowId: string;
    payload: ServicePricePayload;
}

interface UseServicePriceQueriesParams {
    servicesBasePath: ServicesBasePath;
    requests: ServicePriceRequest[];
}

export const useServicePrices = ({ servicesBasePath, requests }: UseServicePriceQueriesParams) => {
    return useQueries({
        queries: requests.map(({ timeWindowId, payload }) => {
            const deliveryMethodId = payload.serviceRequest.deliveryServices[0]?.deliveryMethodId;

            return {
                queryKey: [API.servicePrice, servicesBasePath, payload.buCode, deliveryMethodId, timeWindowId],
                queryFn: async () => {
                    const result = await getServicePrice(servicesBasePath, payload);
                    return result;
                },
            };
        }),
    });
};
